import { ToolItem } from '../types';
import React from 'react';

export default class MenuItem implements ToolItem {
  name: string;
  url: string;
  icon: React.ReactNode;
  active: boolean = false;
  key: string; // 添加 key 属性
  children?: MenuItem[]; // 添加 children 属性，表示子菜单项
  isExpanded: boolean = false; // 添加 isExpanded 属性
  
  constructor(name: string, url: string, icon: React.ReactNode,children: MenuItem[] = [],key: string='') {
    this.name = name;
    this.url = url;
    this.icon = icon;

    this.children = children; // 初始化 children
    this.key = key; // 初始化 key
    //当前的url完全一致，那么就高亮显示
    if (url == '/user/login') {
      this.active =
        window.location.pathname === url ||
        window.location.pathname === '/user/register';
    } else {
        this.active = window.location.pathname === url;
    }
  }
}
